import { atom } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { openOtpModalEvent } from '@root/features/auth/authenticate/otp'

import { EnterOtpDialog } from './enter-otp-dialog'

import type { OpenOtpModalController } from '@root/features/auth/authenticate/otp'

const openOtpParamsAtom = atom<OpenOtpModalController | undefined>(
  undefined,
  'openOtpParamsAtom',
)

openOtpModalEvent.onCall((ctx, controller) => {
  openOtpParamsAtom(ctx, controller)
})

/**
 * @deprecated
 */
export const OtpDialogController = () => {
  const [controller, setController] = useAtom(openOtpParamsAtom)

  return (
    <AnimatePresence>
      {controller ? (
        <EnterOtpDialog
          open
          onOpenChange={(open) => {
            if (!open) {
              setController(undefined)
            }
          }}
          controller={controller}
        />
      ) : undefined}
    </AnimatePresence>
  )
}
